import { SELECT, SEL_BOOKING_TYPE, SEL_CONSIGNMENT_TYPE } from '../common/constants'
import DropDown from '../common/dropDown'
import DropDownOA from '../common/dropDownOA'
import LineInputV2 from '../common/lineinputV2'
import { getPaymentMode } from '../common/paymentsMode'
import { Item } from '../common/snippets'

export const SearchForm = (props) => {
  const { backAction, headerLabel, cnsgnmntTypes, companySettings, paymentTypes } = props
  return (
    <div className="searchform">
      <div className="form-inner">
        <Item>
          <DropDownOA
            type={SEL_CONSIGNMENT_TYPE}
            defaultvalue={'Select consignment Type'}
            data={cnsgnmntTypes || []}
            width="100%"
            searchPlaceholder={'Search Consignment Type'}
            label={``}
            portal={true}
            isObjArr={true}
          />
        </Item>
        <Item>
          <DropDownOA
            type={SEL_BOOKING_TYPE}
            defaultvalue={getPaymentMode(companySettings?.DefaultPaymentType)?.name || ''}
            data={paymentTypes || []}
            width="100%"
            searchPlaceholder={'Select Payment Type'}
            label={`Select Payment Type`}
            isObjArr={true}
            dataKey={`name`}
            idKey={`typeId`}
            tabIndex="5"
          />
        </Item>
        <Item>
          <DropDownOA
            type={SEL_BOOKING_TYPE}
            defaultvalue={getPaymentMode(companySettings?.DefaultPaymentType)?.name || ''}
            data={paymentTypes || []}
            width="100%"
            searchPlaceholder={'Select Option Search By'}
            label={`Select Option Search By`}
            isObjArr={true}
            dataKey={`name`}
            idKey={`typeId`}
            tabIndex="5"
          />
        </Item>
        <Item>
          <div className={'input--wrapper'} style={{ width: '100%' }}>
            <LineInputV2
              disabled={false}
              id={''}
              label={'LR Number'}
              type="phone"
              name="sendMobNo"
              maxLength={10}
              value={''}
              filter={false}
            />
          </div>
        </Item>
      </div>
      <div className="bottom-container">
        <div className="scan-button flex-center-all">scan qr</div>
        <div className="search-button main-button flex-center-all">search</div>
      </div>
    </div>
  )
}
